module.exports = __webpack_public_path__ + "img/pizzette_prep.89d15c5d.jpg";